import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { getSessionToken } from 'utils/track';
import { setAlert, setSuccessAlert } from 'actions/alerts';
function shareContent(_x) {
  return _shareContent.apply(this, arguments);
}
function _shareContent() {
  _shareContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(shareContentsData) {
    var subject, message, user_ids, team_ids, share_ref_ids, share_context_ids, sendEmail, teamShare, label, searchQuery, limit, shareContents;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          subject = shareContentsData.subject, message = shareContentsData.message, user_ids = shareContentsData.user_ids, team_ids = shareContentsData.team_ids, share_ref_ids = shareContentsData.share_ref_ids, share_context_ids = shareContentsData.share_context_ids, sendEmail = shareContentsData.sendEmail, teamShare = shareContentsData.teamShare, label = shareContentsData.label, searchQuery = shareContentsData.searchQuery, limit = shareContentsData.limit;
          shareContents = {
            subject: subject,
            message: message,
            sendEmail: sendEmail,
            teamShare: teamShare,
            user_ids: user_ids,
            team_ids: team_ids,
            share_ref_ids: share_ref_ids,
            share_context_ids: share_context_ids,
            label: label,
            searchQuery: searchQuery,
            limit: limit,
            session_token: getSessionToken(),
            type: shareContentsData.type || null
          };
          return _context.abrupt("return", api('post', '/api/recommendations', null, shareContents));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _shareContent.apply(this, arguments);
}
function useShareContent(options) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useMutation = useMutation(_objectSpread({
      mutationFn: shareContent,
      onSuccess: function onSuccess() {
        setSuccessAlert({
          title: t('alert_share_content_success')
        });
      },
      onError: function onError() {
        setAlert({
          title: t('alert_share_content_error')
        });
      }
    }, options)),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread({
    shareContent: mutateAsync
  }, result);
}
export default useShareContent;